import React, { useEffect, useState } from 'react';
import { fetchTriageStats } from '../lib/api';
import { TriageStats } from '../types';
import { HomeWelcomeBanner } from '../components/home/HomeWelcomeBanner';
import { HomeStatsOverview } from '../components/home/HomeStatsOverview';
import { HomeStudyBlocks } from '../components/home/HomeStudyBlocks';

export const HomePage: React.FC = () => {
  const [stats, setStats] = useState<TriageStats>({
    totalAttempts: 0,
    avgTimeSeconds: 0,
    accuracyRate: 0,
    failureBreakdown: {
      OBSCURED_THEORY: 0,
      FORGOT_FORMULA: 0,
      CALCULATION_ERROR: 0,
      MISREAD_INPUTS: 0,
    },
    subjectCounts: {},
  });

  useEffect(() => {
    async function loadData() {
      try {
        const data = await fetchTriageStats();
        setStats(data);
      } catch {
        // use default stats
      }
    }
    loadData();
  }, []);

  return (
    <div className="min-h-[calc(100vh-3.5rem)] bg-paper-50 px-4 py-8 dark:bg-study-slate sm:px-6">
      <div className="mx-auto max-w-5xl space-y-8">
        <HomeWelcomeBanner />
        <HomeStatsOverview stats={stats} />
        <HomeStudyBlocks />
      </div>
    </div>
  );
};
